import { useEffect, useState } from "react";
import { HttpError, request } from "../api/http";
import { useAuth } from "../context/AuthContext";
import { useMarket } from "../context/MarketContext";

type HealthResponse = { ready: boolean };
type Status = "loading" | "ok" | "error";

export default function Health() {
  const { token } = useAuth();
  const { markets } = useMarket();
  const [status, setStatus] = useState<Status>("loading");
  const [statusDetail, setStatusDetail] = useState<string>("");

  useEffect(() => {
    let cancelled = false;
    setStatus("loading");
    request<HealthResponse>("/api/admin/health", { token, markets })
      .then((data) => {
        if (cancelled) return;
        setStatus(data.ready ? "ok" : "error");
        setStatusDetail(JSON.stringify(data));
      })
      .catch((err) => {
        if (cancelled) return;
        setStatus("error");
        if (err instanceof HttpError) {
          setStatusDetail(`HTTP ${err.status}`);
        } else {
          setStatusDetail("network error");
        }
      });
    return () => {
      cancelled = true;
    };
  }, [token, markets]);

  return (
    <div style={{ padding: "2rem" }}>
      <section
        style={{
          background: "white",
          padding: "1.5rem",
          borderRadius: "0.75rem",
          borderLeft: "3px solid #0069d9",
          boxShadow: "0 2px 8px rgba(0,0,0,.05)",
          maxWidth: 480,
        }}
      >
        <h2
          style={{
            margin: "0 0 1rem",
            fontSize: ".9rem",
            textTransform: "uppercase",
            fontWeight: 600,
            borderBottom: "2px solid #0069d9",
            paddingBottom: ".5rem",
          }}
        >
          Backend health
        </h2>
        <p style={{ margin: 0, color: "#73879C" }}>
          <code>GET /api/admin/health</code>
        </p>
        <p style={{ marginTop: ".5rem" }}>
          {status === "loading" && "Comprobando..."}
          {status === "ok" && <span style={{ color: "#1a7f37" }}>OK</span>}
          {status === "error" && (
            <span style={{ color: "#c00" }}>Error — {statusDetail}</span>
          )}
        </p>
      </section>
    </div>
  );
}
